import { trpc } from '@/lib/trpc';
import { useLocation } from '@/contexts/LocationContext';

export function useStockIntelligence() {
  const { selectedLocation } = useLocation();
  const locationId = selectedLocation?.id;

  const query = trpc.stockAlerts.getStockIntelligence.useQuery(
    { locationId },
    {
      staleTime: 5 * 60 * 1000, // 5 min
      refetchOnWindowFocus: false,
    }
  );

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
    hasLocation: !!locationId,
  };
}
